export default __webpack_public_path__ + "static/media/image-010.89d1831d.png";